import { render, staticRenderFns } from "./AiReportingChat.vue?vue&type=template&id=467deccd&scoped=true&"
import script from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChat.vue?vue&type=style&index=0&id=467deccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467deccd",
  null
  
)

export default component.exports